// features/team/teamApiSlice.js
import { apiSlice } from './apiSlice'; // Assuming apiSlice is set up similarly
const TEAMS_URL = '/api/teams';

export const teamsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all teams
    getTeams: builder.query({
      query: () => ({
        url: TEAMS_URL,
        method: 'GET',
      }),
      providesTags: ['Team'],
    }),
    // Fetch a single team by ID
    getTeamById: builder.query({
      query: (id) => ({
        url: `${TEAMS_URL}/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Team', id }],
    }),
    // Fetch teams by league ID
    getTeamsByLeague: builder.query({
      query: (leagueId) => ({
        url: `${TEAMS_URL}/league/${leagueId}`,
        method: 'GET',
      }),
      providesTags: (result, error, leagueId) => 
        result 
          ? [...result.map(({ _id }) => ({ type: 'Team', id: _id })), { type: 'Team', id: 'LIST' }]
          : [{ type: 'Team', id: 'LIST' }],
    }),
    // Create a new team
    createTeam: builder.mutation({
      query: (newTeam) => ({
        url: TEAMS_URL,
        method: 'POST',
        body: newTeam,
      }),
      invalidatesTags: ['Team'],
    }),
    // Update an existing team
    updateTeam: builder.mutation({
      query: ({ id, ...updatedTeam }) => ({
        url: `${TEAMS_URL}/${id}`,
        method: 'PUT',
        body: updatedTeam,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Team', id }],
    }),    // Delete a team
    deleteTeam: builder.mutation({
      query: (id) => ({
        url: `${TEAMS_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Team'],
    }),
    // Get team leaderboard for a league
    getTeamLeaderboard: builder.query({
      query: (leagueId) => ({
        url: `${TEAMS_URL}/leaderboard/${leagueId}`,
        method: 'GET',
      }),
      providesTags: ['Team', 'Leaderboard'],
    }),
    // Get league statistics
    getLeagueStats: builder.query({
      query: (leagueId) => ({
        url: `${TEAMS_URL}/league-stats/${leagueId}`,
        method: 'GET',
      }),
      providesTags: ['Team', 'LeagueStats'],
    }),
    // Update league points
    updateLeaguePoints: builder.mutation({
      query: (leagueId) => ({
        url: `${TEAMS_URL}/update-league-points/${leagueId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Team', 'Leaderboard', 'LeagueStats'],
    }),
  }),
});

export const {
  useGetTeamsQuery,
  useGetTeamByIdQuery,
  useGetTeamsByLeagueQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
  useGetTeamLeaderboardQuery,
  useGetLeagueStatsQuery,
  useUpdateLeaguePointsMutation,
} = teamsApiSlice;